import { Navigate } from "react-router-dom";

const ScouterProtectedRoute = ({ children }) => {
  const isScouterAuthenticated = localStorage.getItem("scouterToken");
  return isScouterAuthenticated ? children : <Navigate to="/scout" replace />;
};

export default ScouterProtectedRoute;
